// Auto-generated icon module
const svg = `<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
  <path d="M14.6,0H3.4C1.5,0,0,1.5,0,3.4c0,0,0,0,0,0v11.2C0,16.5,1.5,18,3.4,18c0,0,0,0,0,0h11.3c1.9,0,3.4-1.5,3.4-3.4l0,0V3.4
    C18,1.5,16.5,0,14.6,0C14.6,0,14.6,0,14.6,0z M4.5,15.8c-1.2,0-2.3-1-2.3-2.3s1-2.3,2.3-2.3s2.3,1,2.3,2.3S5.7,15.8,4.5,15.8z
     M9,15.8C9,12,6,9,2.3,9V6.8c5,0,9,4,9,9H9z M13.5,15.8c0-6.2-5-11.3-11.3-11.3V2.3c7.5,0,13.5,6,13.5,13.5H13.5z" transform="translate(3 3)" />
</svg>
`;

export { svg as default };
//# sourceMappingURL=it-rss-square-CtNRGa74.js.map
